document.addEventListener("DOMContentLoaded", function() {

  /* Video modal handling */
  var resetInterval;
  document.querySelector(".video-button").onclick = function () {
    document.getElementById("videoModal").classList.add("visible");
    resetInterval = setInterval(function () {
      resetTimer();
    }, 1000);
  };

  document.querySelector("#videoModal").onclick = function () {
    stopVideo();
    clearInterval(resetInterval);
    document.getElementById("videoModal").classList.remove("visible");
  };

  document.querySelector("#closeButton").onclick = function () {
    stopVideo();
    clearInterval(resetInterval);
    document.getElementById("videoModal").classList.remove("visible");
  };

  document.querySelector("#videoModal .modal-content").onclick = function (e) {
    e.stopPropagation();
  };

  document.onkeydown = function (evt) {
    evt = evt || window.event;
    var isEscape = false;
    if ("key" in evt) {
      isEscape = (evt.key === "Escape" || evt.key === "Esc");
    } else {
      isEscape = (evt.keyCode === 27);
    }
    if (isEscape && document.getElementById("videoModal").classList.contains("visible")) {
      stopVideo();
      document.getElementById("videoModal").classList.remove("visible");
      clearInterval(resetInterval);
    }
  };
  /* End of video modal handling */

    var slideId = 1;
    var prevSlideId = 1;
    document.addEventListener('touchstart', handleTouchStart, false);
    document.addEventListener('touchmove', handleTouchMove, false);

    var xDown = null;
    var yDown = null;

    function handleTouchStart(evt) {
        xDown = evt.touches[0].clientX;
        yDown = evt.touches[0].clientY;
    }

    function handleTouchMove(evt) {
        if ( ! xDown || ! yDown ) {
            return;
        }

        var xUp = evt.touches[0].clientX;
        var yUp = evt.touches[0].clientY;

        var xDiff = xDown - xUp;
        var yDiff = yDown - yUp;

        if ( Math.abs( xDiff ) > Math.abs( yDiff ) ) {/*most significant*/
            if ( xDiff > 0 ) {
                if (slideId < 6) {
                  slideId += 1;
                  startAnimation();
                    /* left swipe */
                }
            } else {
                if (slideId > 1) {
                  slideId -= 1;
                  startAnimation();
                }
            }
        }
        /* reset values */
        xDown = null;
        yDown = null;
    }


    function startAnimation() {
        //reset clock hands position
      if (slideId < 7 && slideId > 0) {
        document.getElementById("hourHandAnimationReverse").beginElement();
        document.getElementById("minuteHandAnimationReverse").beginElement();
        document.querySelectorAll(".timeline svg circle").forEach(function (element) {
          element.classList.remove('active');
          element.classList.remove('visited');
          element.setAttribute("r", 4);
        });
        document.querySelectorAll(".timeline .items a.active").forEach(function (element) {
          element.classList.remove("active");
        });
        document.querySelectorAll("#content>.slide").forEach(function (element) {
          element.classList.remove("active");
        });
        document.querySelector(".timeline .items a:nth-child(2)").classList.remove("active");
        var slideIdDuplicate = slideId;
        while (--slideIdDuplicate > 0) {
            document.getElementById('circle'+slideIdDuplicate).setAttribute("class", "visited");
        }
        setTimeout(function () {
          document.querySelector(".timeline .items a:nth-child("+slideId+")").classList.add("active");
          document.getElementById("circle"+slideId).setAttribute("r", 6);
          document.getElementById("circle"+slideId).classList.add('active');
        }, 500);
        setTimeout(function () {
          document.getElementById("slide"+slideId).classList.add("active");
        }, 1000);

        // If going back in slider, should add class visited to selected slide itself and all points before it
        if (slideId < prevSlideId) {
          document.getElementById("circle"+slideId).setAttribute("class", "visited");
        }
        prevSlideId = slideId;
        if (slideId > 5) {
          document.getElementById("nextSlide").classList.remove("visible");
        }
        else {
          document.getElementById("nextSlide").classList.add("visible");
          document.querySelector("#footer").classList.add("visible");
          document.querySelector("#header").classList.add("active");
        }

        if (slideId > 1) {
          document.getElementById("prevSlide").classList.add("visible");
          document.querySelector(".video-button").classList.add("visible");
        }
        else {
          document.getElementById("prevSlide").classList.remove("visible");
          document.querySelector(".video-button").classList.remove("visible");
        }

        if (slideId !== 5) {
          document.querySelectorAll(".hooman.active").forEach(function (element) {
            element.classList.remove("active");
          });
        }

        switch (slideId) {
          case 1: {
            document.getElementById("content").style.cssText = "left: 0;";
            document.querySelector(".timeline .line").style.cssText = "width: 0";
          }
            break;
          case 2: {
            document.getElementById("content").style.cssText = "left: -1024px;";
            document.querySelector(".timeline .line").style.cssText = "width: 135px";
          }
            break;
          case 3: {
            document.getElementById("content").style.cssText = "left: -2048px;";
            document.querySelector(".timeline .line").style.cssText = "width: 270px";
          }
            break;
          case 4: {
            document.getElementById("content").style.cssText = "left: -3072px;";
            document.querySelector(".timeline .line").style.cssText = "width: 405px";
            setTimeout(function () {
              document.getElementById("minuteHandAnimation").beginElement();
              document.getElementById("hourHandAnimation").beginElement();
            }, 1700);
          }
            break;
          case 5: {
            document.getElementById("content").style.cssText = "left: -4096px;";
            document.querySelector(".timeline .line").style.cssText = "width: 535px";
            setTimeout( function () {
              eventFire(document.querySelector('.tab.active'), 'click');
            }, 1500)
          }
            break;
          case 6: {
            document.querySelector(".timeline .line").style.cssText = "width: 670px";
            document.getElementById("content").style.cssText = "left: -5120px;";
            document.querySelector("#header").classList.remove("active");
            document.querySelector(".video-button").classList.remove("visible");
            document.querySelector("#footer").classList.remove("visible");
          }
            break;
          default: {}
            break;
        }
      }

    }

    setTimeout(function () {
        document.getElementById("slide1").classList.add("active");
    }, 2000);

    /* Handling window size */
    if (window.innerWidth < 1024) {
        document.getElementById("warning").classList.add("visible");
        document.getElementById("frame").classList.remove("visible");
    }
    window.addEventListener('resize', function(){
        if (window.innerWidth < 1024) {
            document.getElementById("warning").classList.add("visible");
            document.getElementById("frame").classList.remove("visible");
        }
        else {
            document.getElementById("warning").classList.remove("visible");
            document.getElementById("frame").classList.add("visible");
        }
    }, true);
    /* End of handling window size */

    /* Handling inactivity */
    var timeoutID;
    var inactive = false;

    function setup() {
        this.addEventListener("mousemove", resetTimer, false);
        this.addEventListener("mousedown", resetTimer, false);
        this.addEventListener("keypress", resetTimer, false);
        this.addEventListener("DOMMouseScroll", resetTimer, false);
        this.addEventListener("mousewheel", resetTimer, false);
        this.addEventListener("touchmove", resetTimer, false);
        this.addEventListener("touchstart", resetTimer, false);
        this.addEventListener("MSPointerMove", resetTimer, false);

        startTimer();
    }
    setup();

    function startTimer() {
        // wait 60 seconds before calling goInactive
        timeoutID = window.setTimeout(goInactive, 60000);
    }

    function resetTimer() {
        if (!inactive) {
            window.clearTimeout(timeoutID);
            startTimer();
        }
    }

    function goInactive() {
        if (!inactive) {
            inactive = true;
            document.getElementById("inactiveModal").classList.add("visible");
            document.getElementById("frame").classList.remove("visible");
        }
    }

    function goActive() {
        inactive = false;
        document.getElementById("frame").classList.add("visible");
        document.getElementById("inactiveModal").classList.remove("visible");
        startTimer();
    }

    document.getElementById("continueWatching").onclick = function() {
        goActive();
    };

    var buttonsToStart = document.querySelectorAll(".backToStart");
    for (var i = 0; i < buttonsToStart.length; i++) {
        buttonsToStart[i].addEventListener('click', function(i) {
            goActive();
            document.querySelectorAll(".timeline .items a.active").forEach(function (element) {
                element.classList.remove("active");
            });
            slideId = 1;
            startAnimation();
        }.bind(this, i));
    }
    /* End of handling inactivity */

    /* Next slide click handler */
    document.getElementById("nextSlide").onclick = function() {
        slideId += 1;
        startAnimation();
    };

    /* Prev slide click handler */
    document.getElementById("prevSlide").onclick = function() {
        slideId -= 1;
        startAnimation();
    };

    var bullets = document.querySelectorAll(".timeline .items>a");
    for (var i = 0; i < bullets.length; i++) {
      var thatBullet = bullets[i];
        bullets[i].addEventListener('click', function(thatBullet, i) {
          if (!thatBullet.classList.contains('active')) {
            slideId = i+1;
            startAnimation();
          }
        }.bind(this, thatBullet, i));
    }


    //Fifth slide tabs handling
    var tabs = document.querySelectorAll("#slide5 .tab");
    var lock = false;
    for (var i = 0; i < tabs.length; i++) {
        tabs[i].addEventListener('click', function(i) {
            if (!lock) {
                lock = true;
                document.querySelectorAll(".hooman.active").forEach(function (element) {
                    element.classList.remove("active");
                });
                document.querySelector("#slide5 .tab.active").classList.remove("active");
                tabs[i].classList.add("active");
                var percent = parseInt(tabs[i].dataset.percent);
                var manCount = (58 * percent).toString().substr(0,2);
                var time = percent * 12;
                var hoomans = document.querySelectorAll(".hooman");
                setTimeout(function () {
                    for (var i = 0; i < manCount; i++) {
                        hoomans[i].classList.add("active");
                    }
                    animateValue("percent-container", 0, percent, time);
                }, 50);
                setTimeout(function () {
                    lock = false;
                }, 500);
            }


        }.bind(this, i));
    }

    function animateValue(id, start, end, duration) {
        var range = end - start;
        var current = start;
        var increment = end > start? 1 : -1;
        var stepTime = Math.abs(Math.floor(duration / range));
        var obj = document.getElementById(id);
        var timer = setInterval(function() {
            current += increment;
            obj.innerHTML = current;
            if (current == end) {
                clearInterval(timer);
            }
        }, stepTime);
    }

    function eventFire(el, etype){
        if (el.fireEvent) {
            el.fireEvent('on' + etype);
        } else {
            var evObj = document.createEvent('Events');
            evObj.initEvent(etype, true, false);
            el.dispatchEvent(evObj);
        }
    }

});
